import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { LoginScreen } from "../../authentication/ui/LoginScreen";
import * as React from "react";
import { NotFoundPage } from "../../common/ui/NotFoundPage";
import { LayoutsWithNavbar } from "./LayoutWithNavbar";
import { authenticationStateHandler } from "../../authentication/logic/AuthenticationStateHandler";
import { useObservable } from "../../common/ui/ObservableHook";
import LinkingEmailConfirmationScreen from "../../authentication/ui/LinkingEmailConfirmationScreen";
import { RegistrationScreen } from "../../authentication/ui/RegistrationScreen";
import { ResetPasswordScreen } from "../../authentication/ui/ResetPasswordSceen";
import LinkingResetPasswordScreen from "../../authentication/ui/LinkingResetPasswordScreen";
import GroupsPage from "../../pages/groups/Groups";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocale } from "../../hooks/UseLocale";
import CompanyManagement from "../../pages/companyManagement/CompanyManagement";
import ActionModules from "../../pages/actionModules/ActionModules";
import Certificates from "../../pages/documentManagement/Certificates/Certificates";
import SuperAdminArea from "../../pages/superAdminArea/SuperAdminArea";
import Dashboard from "../../pages/dashboard/Dashboard";
import { keyValueStorage } from "../../common/logic/KeyValueStore";
import AppDesignPage from "../../pages/configuration/AppDesign/AppDesignPage";
import { setCreateMode, setEditMode } from "../../store/reducers/tableManagementReducer";
import { useAppDispatch } from "../../hooks/StoreHooks";
import UpcomingBonusRewardsAnalysisFilesAdminPage from "../../pages/superAdminArea/AnalysisFiles/UpcomingBonusRewardsAnalysisFilesAdminPage";
import UpcomingBonusRewardsAnalysisFilesPage from "../../pages/billing/analysisFiles/UpcomingBonusRewardsAnalysisFilesPage";
import BoughtVouchersAnalysisFilesAdminPage from "../../pages/superAdminArea/AnalysisFiles/BoughtVouchersAnalysisFilesAdminPage";
import NewEmployeesAnalysisFilesAdminPage from "../../pages/superAdminArea/AnalysisFiles/NewEmployeesAnalysisFilesAdminPage";
import BoughtVouchersAnalysisFilesPage from "../../pages/billing/analysisFiles/BoughtVouchersAnalysisFilesPage";
import NewEmployeesAnalysisFilesPage from "../../pages/billing/analysisFiles/NewEmployeesAnalysisFilesPage";
import InvoicesAdminPage from "../../pages/superAdminArea/Invoices/InvoicesAdminPage";
import InvoicesPage from "../../pages/billing/invoices/InvoicesPage";
import ServiceModulesPage from "../../pages/serviceModules/ServiceModulesPage";
import CalendarPage from "../../pages/serviceModules/Calendar/CalendarPage";
import Wallet from "../../pages/wallet/Wallet";
import Transactions from "../../pages/wallet/transactions/Transactions";
import WalletTypesPage from "../../pages/wallet/walletTypes/WalletTypesPage";
import Employees from "../../pages/employees/Employees";
import ActionModuleIncentivationPage from "../../pages/incentivation/actionModules/ActionModuleIncentivationPage";
import FolderServicePage from "../../pages/serviceModules/Folder/FolderServicePage";
import DirectPayoutAnalysisFilesPage from "../../pages/billing/analysisFiles/DirectPayoutAnalysisFilesPage";
import DirectPayoutAnalysisFilesAdminPage from "../../pages/superAdminArea/AnalysisFiles/DirectPayoutAnalysisFilesAdminPage";
import { ProfilePage } from "../../pages/profile/ProfilePage";
import LeaderboardPage from "../../pages/serviceModules/Leaderboard/LeaderboardPage";
import StatusPage from "../../pages/serviceModules/Status/StatusPage";
import PermissionsPage from "../../pages/permissions/PermissionsPage";
import CompanyPensionAnalysisFilesPage from "../../pages/billing/analysisFiles/CompanyPensionAnalysisFilesPage";
import CompanyPensionAnalysisFilesAdminPage from "../../pages/superAdminArea/AnalysisFiles/CompanyPensionAnalysisFilesAdminPage";
import LinkingSetPasswordScreen from "../../authentication/ui/LinkingSetPasswordScreen";
import SingleEmployee from "../../pages/employees/EmployeePage/SingleEmployee";
import TimeTrackingModulePage from "../../pages/serviceModules/TimeTracking/TimeTrackingModulePage";
import TimeTrackingAllEntriesPage from "../../pages/serviceModules/TimeTracking/TimeTrackingAllEntriesPage";
import TimeTrackingEmployeeEntriesPage from "../../pages/serviceModules/TimeTracking/TimeTrackingEmployeeEntriesPage";
import AbsenceModulePage from "../../pages/serviceModules/Absence/AbsenceModulePage";
import AbsenceAllEntriesPage from "../../pages/serviceModules/Absence/AbsenceAllEntriesPage";
import AbsenceEmployeeEntriesPage from "../../pages/serviceModules/Absence/AbsenceEmployeeEntriesPage";
import GenericInAppNotificationsPage from "../../pages/notifications/GenericInAppNotificationsPage";
import AuditLogs from "../../pages/auditLogs/AuditLogs";
import { PersonalDocumentsPage } from "../../pages/serviceModules/PersonalDocuments/PersonalDocumentsPage";
import ActionModuleEditorPage from "../../pages/actionModules/ActionModuleEditor/ActionModuleEditorPage";
import ActionModuleListPage from "../../pages/superAdminArea/ActionModuleList/ActionModuleListPage";
import NewActionModuleEditorPage from "../../pages/actionModules/ActionModuleEditor/NewActionModuleEditorPage";
import FullPayoutOverviewPage from "../../pages/billing/analysisFiles/FullPayoutOverviewPage";
import FullPayoutPayoutsPage from "../../pages/billing/analysisFiles/FullPayoutsPage";

export function RouteDefinitions() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch()
  const locale = location.pathname.split("/")[1];
  const navigate = useNavigate();
  const userRole = keyValueStorage.getObject<string>("userRole", "");
  useEffect(() => {
    if (location.pathname === "/") {
      navigate(`/${i18n.language}`);
    }
  }, [i18n.language, location.pathname, navigate]);

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [i18n, locale]);

  useEffect(() => {
    dispatch(setEditMode(false));
    dispatch(setCreateMode(false));
  }, [location, dispatch]);

  const isAuthenticated =
    useObservable(
      authenticationStateHandler.isAuthenticatedObservable,
      authenticationStateHandler.isAuthenticated
    ) ?? false;

  const isSuperAdmin = (userRole === "Administrator")

  return (
    <Routes location={location}>
      <Route path={`/${locale}`} element={<LayoutsWithNavbar />}>
        {isSuperAdmin &&
          <Route
            path={`/${locale}`}
            element={
              <ProtectedRoute
                isLoggedIn={isAuthenticated}
                element={<SuperAdminArea />}
              />
            }
          />
        }
        {locale && (
          <Route
            path={`/${locale}`}
            element={<Navigate to={`/${locale}/employees`} replace />}
          />)}
        <Route
          path={`/${locale}/*`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<NotFoundPage />}
            />
          }
        />
        <Route
          path={`/${locale}/groups`}
          element={
            <ProtectedRoute isLoggedIn={isAuthenticated} element={<GroupsPage />} />
          }
        />
        <Route
          path={`/${locale}/dashboard`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<Dashboard />}
            />
          }
        />
        <Route
          path={`/${locale}/actionmodules`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<ActionModules />}
            />
          }
        />
        <Route
          path={`/${locale}/companies/:companyId/actionmodules/:actionModuleId/editor`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<ActionModuleEditorPage />}
            />
          }
        />
        <Route
          path={`/${locale}/companies/:companyId/actionmodules/new`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<NewActionModuleEditorPage />}
            />
          }
        />
        <Route
          path={`/${locale}/documentManagement/:certificatesTrainings`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<Certificates />}
            />
          }
        />
        <Route
          path={`/${locale}/company-management`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<CompanyManagement />}
            />
          }
        />
        <Route
          path={`/${locale}/employees`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<Employees />}
            />
          }
        />
        <Route
          path={`/${locale}/employees/:employeeId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<SingleEmployee />}
            />
          }
        />
        <Route
          path={`/${locale}/notifications/inApp`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<GenericInAppNotificationsPage />}
            />
          }
        />
        <Route
          path={`/${locale}/incentivation/actionModules/:actionModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<ActionModuleIncentivationPage />}
            />
          }
        />
        <Route
          path={`/${locale}/invoices`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<InvoicesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/analysisfiles/upcomingbonusrewards`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<UpcomingBonusRewardsAnalysisFilesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/analysisfiles/boughtvouchers`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<BoughtVouchersAnalysisFilesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/analysisfiles/newemployees`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<NewEmployeesAnalysisFilesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/analysisfiles/directpayout`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<DirectPayoutAnalysisFilesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/analysisfiles/companypension`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<CompanyPensionAnalysisFilesPage />}
            />
          }
        />
          <Route
              path={`/${locale}/analysisfiles/fullpayout`}
              element={
                  <ProtectedRoute
                      isLoggedIn={isAuthenticated}
                      element={<FullPayoutOverviewPage />}
                  />
              }
          />
          <Route
              path={`/${locale}/analysisfiles/fullpayout/:shopModuleId`}
              element={
                  <ProtectedRoute
                      isLoggedIn={isAuthenticated}
                      element={<FullPayoutPayoutsPage />}
                  />
              }
          />
          <Route
          path={`/${locale}/configuration/app-design`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<AppDesignPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<ServiceModulesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/calendar/:serviceModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<CalendarPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/leaderboard/:serviceModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<LeaderboardPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/statussystem/:serviceModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<StatusPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/timetracking/:serviceModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<TimeTrackingModulePage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/timetracking/:serviceModuleId/all`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<TimeTrackingAllEntriesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/timetracking/:serviceModuleId/employee/:employeeId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<TimeTrackingEmployeeEntriesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/absence/:serviceModuleId/all`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<AbsenceAllEntriesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/absence/:serviceModuleId/employee/:employeeId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<AbsenceEmployeeEntriesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/absence/:serviceModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<AbsenceModulePage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/personaldocuments/:serviceModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<PersonalDocumentsPage />}
            />
          }
        />
        <Route
          path={`/${locale}/wallet`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<Wallet />}
            />
          }
        />
        <Route
          path={`/${locale}/wallet/:walletId/transactions`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<Transactions />}
            />
          }
        />
        <Route
          path={`/${locale}/wallet`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<Wallet />}
            />
          }
        />
        <Route
          path={`/${locale}/wallet/transactions`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<Transactions />}
            />
          }
        />
        <Route
          path={`/${locale}/wallet/types`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<WalletTypesPage />}
            />
          }
        />
        <Route
          path={`/${locale}/servicemodules/folder/:serviceModuleId`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<FolderServicePage />}
            />
          }
        />
        <Route
          path={`/${locale}/profile`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<ProfilePage />}
            />
          }
        />

        <Route
          path={`/${locale}/permissions`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<PermissionsPage />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<SuperAdminArea />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea/actionModules`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<ActionModuleListPage />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea/invoices`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<InvoicesAdminPage />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea/analysisfiles/upcomingbonusrewards`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<UpcomingBonusRewardsAnalysisFilesAdminPage />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea/analysisfiles/boughtvouchers`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<BoughtVouchersAnalysisFilesAdminPage />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea/analysisfiles/newemployees`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<NewEmployeesAnalysisFilesAdminPage />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea/analysisfiles/directpayout`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<DirectPayoutAnalysisFilesAdminPage />}
            />
          }
        />
        <Route
          path={`/${locale}/superadminarea/analysisfiles/companypension`}
          element={
            <SuperAdminRoute
              isSuperAdmin={isSuperAdmin}
              isLoggedIn={isAuthenticated}
              element={<CompanyPensionAnalysisFilesAdminPage />}
            />
          }
        />
        <Route
          path={`/${locale}/auditlogs`}
          element={
            <ProtectedRoute
              isLoggedIn={isAuthenticated}
              element={<AuditLogs />}
            />
          }
        />
      </Route>

      <Route
        path={`/${locale}/login`}
        element={<LoginScreen navigateToUrlWhenLoggedIn="/" />}
      />
      <Route path={`/${locale}/register`} element={<RegistrationScreen />} />
      <Route
        path={`/${locale}/reset_password`}
        element={<ResetPasswordScreen />}
      />
      <Route
        path={`/${locale}/linking/email_confirmation`}
        element={
          <LinkingEmailConfirmationScreen />
        }
      />
      <Route
        path={`/${locale}/linking/password_reset`}
        element={<LinkingResetPasswordScreen />}
      />
      <Route
        path={`/${locale}/linking/register_company_management_user`}
        element={<LinkingSetPasswordScreen />}
      />
      {/*
        Backend links no longer carry a locale prefix (Bonisoft.Backend now builds
        `/linking/...` without `/{locale}/`, shared with the new Bonisoft_Portal). Keep the
        locale-prefixed routes above for any links already sent out, but also match the new,
        locale-less shape so current emails work regardless of the visitor's detected language.
      */}
      <Route
        path="/linking/email_confirmation"
        element={<LinkingEmailConfirmationScreen />}
      />
      <Route
        path="/linking/password_reset"
        element={<LinkingResetPasswordScreen />}
      />
    </Routes>
  );
}

interface ProtectedRouteProps {
  isLoggedIn: boolean;
  element: React.JSX.Element;
}

interface SuperAdminRouteProps {
  isSuperAdmin: boolean;
  isLoggedIn: boolean;
  element: React.JSX.Element;
}

function ProtectedRoute(props: ProtectedRouteProps): React.JSX.Element {
  const locale = useLocale();
  if (props.isLoggedIn) {
    return props.element;
  } else {
    return <Navigate to={`/${locale}/login`} />;
  }
}

function SuperAdminRoute(props: SuperAdminRouteProps): React.JSX.Element {
  const locale = useLocale();
  if (props.isSuperAdmin) {
    return props.element;
  } else {
    return <Navigate to={`/${locale}/login`} />;
  }
}
